import { LocaleService } from '@sm360/widget-commons-core-services';
import { Vehicle } from '@sm360/widget-commons-vehicle';
import PropTypes from 'prop-types';
import React from 'react';

import DrivePowerTrainAndColour from 'vdp-used/components/DrivePowerTrainAndColourSection/DrivePowerTrainAndColour/DrivePowerTrainAndColour.jsx';

const DrivePowerTrainAndColourSection = ({ vehicle }) => {
    return (
        <div className="vdp-used-specs">
            <DrivePowerTrainAndColour
                title={LocaleService.t('VEHICLE_POWER_AND_COLOUR.DRIVE_TRAIN')}
                label={vehicle?.driveTrain?.name}
                iconClass="icon-Front-Wheel-Drive"
            />
            <DrivePowerTrainAndColour
                title={LocaleService.t('VEHICLE_POWER_AND_COLOUR.ENGINE')}
                label={vehicle.engine?.name}
                iconClass="icon-engine"
            />
            <DrivePowerTrainAndColour
                title={LocaleService.t('VEHICLE_POWER_AND_COLOUR.TRANSMISSION')}
                label={vehicle.transmission?.name}
                iconClass="icon-transmission"
            />
            <DrivePowerTrainAndColour
                title={LocaleService.t('VEHICLE_POWER_AND_COLOUR.ODOMETER')}
                label={vehicle?.getOdometer()}
                iconClass="icon-odometer"
            />
            <DrivePowerTrainAndColour
                title={LocaleService.t('VEHICLE_POWER_AND_COLOUR.EXTERIOR_COLOUR')}
                label={vehicle.exteriorColor?.colorDescription}
                colorValue={vehicle.exteriorColor?.hexValue}
                iconClass=""
                imageUrl=""
            />
            <DrivePowerTrainAndColour
                title={LocaleService.t('VEHICLE_POWER_AND_COLOUR.INTERIOR_COLOUR')}
                label={vehicle.interiorColor?.colorDescription}
                colorValue={vehicle.interiorColor?.hexValue}
                iconClass=""
                imageUrl=""
            />
        </div>
    );
};

DrivePowerTrainAndColourSection.propTypes = {
    vehicle: PropTypes.instanceOf(Vehicle.VehicleModel).isRequired,
};

DrivePowerTrainAndColourSection.displayName = 'DrivePowerTrainAndColourSection';

export default DrivePowerTrainAndColourSection;
